
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Group } from "@/lib/types";

interface JoinGroupDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  group: Group;
  onConfirm: () => Promise<void>;
}

export const JoinGroupDialog = ({ 
  open, 
  onOpenChange, 
  group, 
  onConfirm 
}: JoinGroupDialogProps) => {
  const [isJoining, setIsJoining] = React.useState(false);

  const handleJoin = async () => {
    try {
      setIsJoining(true);
      await onConfirm();
      onOpenChange(false);
    } catch (error) {
      console.error("Error joining group:", error);
    } finally {
      setIsJoining(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Join "{group.name}"</DialogTitle>
          <DialogDescription>
            Are you sure you want to join this community?
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <h4 className="text-sm font-medium mb-2">Community Rules:</h4>
          <div className="bg-muted p-3 rounded-md text-sm max-h-48 overflow-y-auto">
            {group.rules ? (
              <div className="whitespace-pre-wrap">{group.rules}</div>
            ) : (
              <p className="text-muted-foreground">
                No specific rules have been set for this community. Please follow general community guidelines and be respectful to all members.
              </p>
            )}
          </div>
        </div>

        <DialogFooter className="sm:justify-between">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            No, Cancel
          </Button>
          <Button 
            type="button" 
            onClick={handleJoin}
            disabled={isJoining}
          >
            {isJoining ? "Joining..." : "Yes, Join Community"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
